import { APP_CONFIG } from '@debbie/cortex/dist/config.js'

export const APIBASE = `${APP_CONFIG.apiBase}/collection-engine`
export const FILEBASE = `${APIBASE}/files`

export const ENABLE_SENTRY = APP_CONFIG.enableSentry
export const SENTRY_DSN = APP_CONFIG.sentryDsn

export const ENV = APP_CONFIG.environment

export const IS_PROD = ENV === 'production'
